import { message } from 'antd'
import axios from 'axios'
message.config({
  maxCount: 1,
})
const serverErrorMsgs = {
  403: '没有权限 代码：403',
  401: '认证失败 代码：401',
  500: '服务器错误 代码：500',
  502: '服务器错误 代码：502',
  504: '服务器超时 代码：504',
}
const delayCloseTime = 2
let sending = false
const info = async function (error, text, cb) {
  await message.error(
    (error && error.response && error.response.data && error.response.data.msg) ||
      text ||
      '服务器错误',
    delayCloseTime,
  )
  typeof cb === 'function' && cb()
}
const httpStatus = {
  403: (error) => {
    const msg = error.response.data.msg || serverErrorMsgs[403]
    info(error, msg)
    const url = window.localStorage.getItem('domainUrl')
    // window.location.href = url +　'/baseplat/user/login';
    return msg
  },
  401: (error) => {
    const msg = error.response.data.msg || serverErrorMsgs[401]
    //not show toast
    // info(error, msg)
    // const url = window.localStorage.getItem('domainUrl')
    // window.localStorage.removeItem('userInfo')
    window.location.href = '/#/account/login'
    // toUserPlat()
    return msg
  },
  500: (error) => {
    const msg = serverErrorMsgs[500]
    info(error, msg)
    return msg
  },
  502: (error) => {
    const msg = serverErrorMsgs[502]
    info(error, msg)
    return msg
  },
  504: (error) => {
    const msg = serverErrorMsgs[504]
    info(error, msg)
    return msg
  },
}
function errorHandle(error) {
  const code = error && error.response && error.response.status
  if (code && httpStatus[code]) {
    return {
      success: false,
      globalError: httpStatus[code](error),
    }
  }
  return {
    success: false,
    globalError: error.response.data.msg || (code && `报错 状态码：${code}`),
  }
}
function tryTrim(data) {
  try {
    if (typeof data === 'object' && !Array.isArray(data)) {
      const trimmedClone = {}
      for (const key of Object.keys(data)) {
        // shallow trim
        trimmedClone[key] = data[key]?.trim ? data[key].trim() : data[key]
      }
      return trimmedClone
    } else if (data?.trim) {
      return data.trim()
    } else {
      return data
    }
  } catch {
    return data
  }
}
const fetch = (options) => {
  const { method = 'GET', url } = options
  let params = null
  let data = null
  if (method === 'GET' && options.data) {
    params = options.data
    data = null
  }
  if (
    (options.method === 'POST' || options.method === 'PUT' || options.method === 'PATCH') &&
    !options.data &&
    options.params
  ) {
    data = tryTrim(options.params)
    params = null
  }
  const timeStamp = `_t=${new Date().getTime()}`
  const query = url.indexOf('?') >= 0 ? '&' : '?'
  sending = true
  let axiosData = {
    method: method || 'GET',
    url: `${url}${query}${timeStamp}`,
    data: data || null,
    params: params || null,
    headers: options.headers || null,
    responseType: options.responseType || null,
  }
  return axios(axiosData)
}
export default function request(options) {
  if (sending && options.lock) {
    return false
  }
  return fetch(options)
    .then((response) => {
      sending = false
      const { statusText, status, fieldErrors } = response
      const { code, msg } = response.data
      let { data } = response
      if (data instanceof Array) {
        data = {
          list: data,
        }
      }
      if (+code === 100000) {
        return Promise.resolve({
          success: true,
          message: statusText,
          msg,
          data,
          statusCode: status,
          ...data,
        })
      }
      return Promise.resolve({
        success: false,
        message: statusText,
        statusCode: status,
        ...data,
        globalError: msg,
        blob: data,
        fieldErrors,
      })
    })
    .catch((error) => {
      sending = false
      return errorHandle(error)
    })
}
